module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/icon-superiority.a9a049dd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/icon-superiority.png
// module id = 2842
// module chunks = 11